import { NgModule } from '@angular/core';
import { GridEmptyComponent } from './gridempty.component';
import { DomSanitizer, BrowserModule } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material';

import { MatIconModule, MatButtonModule } from '@angular/material';

@NgModule({
    imports: [
        MatIconModule, MatButtonModule, BrowserModule
    ],
    entryComponents: [],
    exports: [
        GridEmptyComponent
    ],
    declarations: [
        GridEmptyComponent
    ],
    providers: [],
    bootstrap: []
})
export class GridEmptyModule {}